module.exports = __webpack_public_path__ + "04_long_yellow.e9b8d75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/04_long_yellow.png
// module id = k2XG
// module chunks = 0